import { axiosFactory, errorHandler } from '@/configs/axios'

export const addRule = {
  api: (payload) => {
    return axiosFactory()
      .auth.post('rules/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const editCondition = {
  api: (id, payload) => {
    return axiosFactory()
      .auth.put(`rules/${id}/`, payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const getCondition = {
  api: (payload) => {
    return axiosFactory()
      .auth.get('rules/' + payload + '/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const getMetrics = {
  api: () => {
    return axiosFactory()
      .auth.get('metrics/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const removeCondition = {
  api: (payload) => {
    return axiosFactory()
      .auth.delete('rules/' + payload + '/')
      .then((res) => {
        return true
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const conditionsList = {
  api: (payload = {}) => {
    const queryParams = new URLSearchParams()

    if (payload) {
      for (const [key, value] of Object.entries(payload)) {
        if (value !== null && value !== undefined && value !== '') {
          queryParams.append(key, value)
        }
      }
    }

    const queryString = queryParams.toString()
    const url = `rules/${queryString ? '?' + queryString : ''}`

    return axiosFactory()
      .auth.get(url)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}
